export default "__VITE_ASSET__7ad7e059__"